var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime, Settings } from 'luxon';
Settings.defaultLocale = 'en-US';
export var DateFormat;
(function (DateFormat) {
    DateFormat["Date"] = "date";
    DateFormat["DateTime"] = "date-time";
    DateFormat["DateMonth"] = "date-month";
    DateFormat["DateMonthDash"] = "date-month-dash";
    DateFormat["WeekNumber"] = "week-number";
    DateFormat["Month"] = "month";
})(DateFormat || (DateFormat = {}));
var defaultArgs = function () { return ({
    date: DateTime.utc().toJSDate(),
    format: DateFormat.DateMonth,
}); };
export var formatDate = function (args) {
    var _a = __assign(__assign({}, defaultArgs()), (args !== null && args !== void 0 ? args : {})), date = _a.date, format = _a.format;
    var d = DateTime.fromJSDate(date);
    switch (true) {
        case format === DateFormat.Date: {
            return d.toISODate();
        }
        case format === DateFormat.DateTime: {
            return d.toFormat('DD t');
        }
        case format === DateFormat.DateMonth: {
            return d.toFormat('DD');
        }
        case format === DateFormat.DateMonthDash: {
            return d.toFormat('DD').replace(/\s/g, '-').replace(/,/g, '');
        }
        case format === DateFormat.WeekNumber: {
            return "Week ".concat(d.weekNumber);
        }
        case format === DateFormat.Month: {
            return d.monthShort;
        }
    }
    return d.toISODate();
};
export var isoStringToDate = function (value) {
    return DateTime.fromISO(value).toJSDate();
};
export var isCurrentWeek = function (weekNumber, year) {
    var _a = DateTime.now(), currentWeekNumber = _a.weekNumber, currentYear = _a.year;
    return weekNumber === currentWeekNumber && year === currentYear;
};
export var isPreviousWeek = function (weekNumber, year) {
    var _a = DateTime.now().minus({ week: 1 }).endOf('week'), previousWeekNumber = _a.weekNumber, previousWeekYear = _a.year;
    return weekNumber === previousWeekNumber && year === previousWeekYear;
};
export var getLastWeek = function () {
    var _a = DateTime.now().minus({ week: 1 }).endOf('week'), weekNumber = _a.weekNumber, year = _a.year;
    return { weekNumber: weekNumber, year: year };
};
export var getDateRangeBounds = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, weekRange = _a.weekRange;
    if (endDate <= startDate) {
        return {
            weekTo: startDate.weekNumber,
            yearTo: startDate.year,
            weekFrom: startDate.weekNumber,
            yearFrom: startDate.year,
        };
    }
    var today = DateTime.now();
    var duration = endDate.diff(startDate, ['weeks']);
    var weekFrom = startDate.weekNumber;
    var yearFrom = startDate.year;
    var weekTo = today.weekNumber;
    var yearTo = today.year;
    if (endDate.toISO() < today.toISO()) {
        weekTo = endDate.weekNumber;
        yearTo = endDate.year;
    }
    if (duration.weeks > weekRange) {
        var fromDate = DateTime.fromObject({
            weekNumber: weekTo,
            weekYear: yearTo,
        }).minus({ week: weekRange });
        yearFrom = fromDate.year;
        weekFrom = fromDate.weekNumber;
    }
    return {
        weekFrom: weekFrom,
        yearFrom: yearFrom,
        weekTo: weekTo,
        yearTo: yearTo,
    };
};
//# sourceMappingURL=dates.js.map